import { Document } from '@transferwise/icons';
import Body from '../../../body/Body.mjs';
import Button from '../../../button/Button.resolver.mjs';
import Title from '../../../title/Title.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Typography } from '../../../common/propsValues/typography.mjs';

function CompleteStep({
  csButtonText,
  csSuccessText,
  fileName,
  isComplete,
  isImage,
  onClear,
  uploadedImage
}) {
  return /*#__PURE__*/jsx("div", {
    className: "droppable-complete-card droppable-card",
    "aria-hidden": !isComplete,
    children: /*#__PURE__*/jsxs("div", {
      className: "droppable-card-content",
      children: [/*#__PURE__*/jsxs("div", {
        className: "droppable-card-content d-flex flex-column align-items-center",
        "aria-live": "polite",
        children: [isImage && uploadedImage ? /*#__PURE__*/jsx("img", {
          src: uploadedImage,
          alt: "OK",
          className: "thumbnail "
        }) : /*#__PURE__*/jsx(Document, {}), fileName && /*#__PURE__*/jsx(Body, {
          as: "p",
          className: "m-b-0",
          children: fileName
        }), csSuccessText && /*#__PURE__*/jsx(Title, {
          className: "caption m-t-1",
          type: Typography.TITLE_BODY,
          children: csSuccessText
        })]
      }), csButtonText && /*#__PURE__*/jsx(Button, {
        v2: true,
        className: "m-t-1",
        onClick: onClear,
        children: csButtonText
      })]
    })
  });
}

export { CompleteStep as default };
//# sourceMappingURL=completeStep.mjs.map
